/**
 * Define exam mixin
 *
 * @author minkyoung.park@emcast.com
 */
export const examMixin = {
  methods: {
    // move prev route
    routerGoPrev(action) {
      let type = this.$route.query.type;
      if (type === "formal-evolution") {
        let status = this.$route.query.status;
        if (status === "LEARNING" || status === "COMPLETION") {
          this.$router.push({
            name: "LearnView",
            params: this.$route.params.learnId,
            query: { status: this.$route.query.status }
          });
        } else {
          this.$router.go(-1);
        }
      } else {
        if (
          action !== undefined &&
          action.find(arr => arr.action === "can_re_start")
        ) {
          this.$router.push(
            "/independent/exam/result/" +
              this.$route.params.examineeId +
              "?examresult=getscore"
          );
        } else {
          if (
            this.$route.matched[this.$route.matched.length - 1].path ==
            "/independent/exam/my/:examineeId"
          ) {
            this.$router.push("/independent/exam?listType=my");
          } else if (
            this.$route.matched[this.$route.matched.length - 1].path ==
            "/independent/exam/result/:examineeId"
          ) {
            this.$router.push("/independent/exam?listType=result");
          } else if (
            this.$route.matched[this.$route.matched.length - 1].path ==
            "/independent/exam/my/:examineeId/take"
          ) {
            this.$router.push("/independent/exam?listType=my");
          } else {
            //this.$router.go(-1)
            this.$router.push({
              name: this.$route.matched[this.$route.matched.length - 2].name,
              params: this.$route.params,
              query: {
                status: this.$route.query.status,
                examresult: "getscore"
              }
            });
          }
        }
      }
    },

    // 단독시험 여부 확인(check independent exam)
    isIndependentExamTake() {
      let routeName = this.$route.name;
      return routeName.indexOf("Independent") >= 0;
    },

    // 단독시험 결과 확인(check independent exam result)
    isIndependentExamReTake() {
      let routeName = this.$route.name;
      return routeName.indexOf("result") >= 0;
    },

    // 형성평가 시험 응시 확인(check lesson exam)
    isLessonExamTake() {
      let routeName = this.$route.name;
      return routeName.indexOf("Lesson") >= 0;
    },

    // 정규평가 시험 응시 확인(check final exam)
    isFinalExamTake() {
      let routeName = this.$route.name;
      return routeName.indexOf("Final") >= 0;
    },

    isMicroExamTake() {
      let routeName = this.$route.name;
      return routeName.indexOf("Micro") >= 0;
    },

    // 시험 시작(Start Exam)
    startExam() {
      let routeName = "";
      if (this.isIndependentExamTake()) {
        if (this.isIndependentExamReTake()) {
          routeName = "IndependentExamResultTake";
        } else {
          routeName = "IndependentExamTake";
        }
      } else if (this.isLessonExamTake()) {
        routeName = "LessonExamTake";
      } else if (this.isMicroExamTake()) {
        routeName = "MicroExamTake";
      } else if (this.isFinalExamTake()) {
        routeName = "FinalExamTake";
      }
      this.$router.push({
        name: routeName,
        params: this.$route.params,
        query: this.$route.query
      });
    },

    // 시험 결과로 이동(move exam result)
    moveExamResult() {
      let routeName = "";
      if (this.isIndependentExamTake()) {
        routeName = "IndependentExamResultView";
      } else if (this.isLessonExamTake()) {
        routeName = "LessonExamResult";
      } else if (this.isFinalExamTake()) {
        routeName = "FinalExamResult";
      }

      this.$router.push({
        name: routeName,
        params: this.$route.params,
        query: this.$route.query
      });
    },

    // 시험 피드백으로 이동(move exam feedback)
    moveExamFeedback() {
      let routeName = "";
      if (this.isIndependentExamTake()) {
        routeName = "IndependentExamResultFeedback";
      } else if (this.isLessonExamTake()) {
        routeName = "LessonExamFeedback";
      } else if (this.isFinalExamTake()) {
        routeName = "FinalExamFeedback";
      }

      this.$router.push({
        name: routeName,
        params: { paperId: this.paperId },
        query: this.$route.query
      });
    },

    // 문항 이이제기로 이동(move question issue)
    moveIssue() {
      let routeName = "";
      if (this.isIndependentExamTake()) {
        routeName = "IndependentExamResultFeedbackIssue";
      } else if (this.isLessonExamTake()) {
        routeName = "LessonExamFeedbackIssue";
      } else if (this.isFinalExamTake()) {
        routeName = "FinalExamFeedbackIssue";
      }

      this.$router.push({
        name: routeName,
        params: { questionId: this.questionId },
        query: this.$route.query
      });
    },

    // 문항 질문하기로 이동(move question FAQ)
    moveQuestion() {
      let routeName = "";
      if (this.isMicroExamTake()) {
        routeName = "MicroExamFeedbackQuestion";
      } else if (this.isIndependentExamTake()) {
        routeName = "IndependentExamResultFeedbackQuestion";
      } else if (this.isLessonExamTake()) {
        routeName = "LessonExamFeedbackQuestion";
      } else if (this.isFinalExamTake()) {
        routeName = "FinalExamFeedbackQuestion";
      }

      // console.log('currentGroupIndex',this.$route.query)
      this.$router.push({
        name: routeName,
        params: {
          questionId: this.questionId
        },
        query: {
          listType: this.$route.query.listType,
          tb: this.currentGroupIndex
        }
      });
    }
  }
};
